export default "__VITE_ASSET__WenInu2o__"